<template>
  <section>
    <div v-if="!steps.length">
      <div v-if="owner">
        <div class="has-text-centered pb-5">
          <div class="columns is-centered is-paddingless is-marginless">
            <div class="column is-3">
              <b-image
                src="https://costuto-public.s3.eu-central-1.amazonaws.com/images/tanukos.png"
                alt="Tanukos"
                ratio="1by1"
              ></b-image>
            </div>
          </div>
          <h2 class="subtitle">Create the first step for your {{ steppableType }}!</h2>
          <div class="p-2">
            <b-button
              class="p-5"
              rounded
              size=" is-success is-large is-link "
              @click="triggerNewStepModal(0)"
            >
              <b-icon icon="plus"> </b-icon>
            </b-button>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="section has-text-centered">
          <h2 class="subtitle has-text-gray is-italic">
            This {{ steppableType }} has no step yet.
          </h2>
        </div>
      </div>
    </div>

    <div v-else class="container">
      <div class="buttons is-centered">
        <b-button
          v-if="owner && editingStatus === false"
          class="is-warning is-inverted"
          size="is-medium"
          icon-left="pencil"
          rounded
          @click="editingStatus = true"
          >Modify steps</b-button
        >
        <b-button
          v-if="owner && editingStatus"
          class="is-danger"
          size="is-medium"
          icon-left="stop"
          rounded
          @click="editingStatus = false"
          >Stop Editing</b-button
        >
      </div>

      <div>
        <div class="has-text-centered p-2" v-if="owner && editingStatus">
          <b-button
            class="p-5"
            rounded
            size=" is-success is-large is-link "
            @click="triggerNewStepModal(0)"
          >
            <b-icon icon="plus"> </b-icon>
          </b-button>
        </div>

        <div v-for="(step, index) in steps" :key="step.id">
          <step
            :index="index"
            :step="step"
            :editing="editing"
            @deleteStep="deleteStep"
            @updateStep="updateStep"
            @stepUpdated="steps = $event"
          />
          <div v-if="owner && editing" class="has-text-centered p-2">
            <b-button
              class="p-5"
              rounded
              size=" is-success is-large is-link "
              @click="triggerNewStepModal(step.attributes.steppable_order_rank + 1)"
            >
              <b-icon icon="plus"> </b-icon>
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      :active.sync="isNewStepModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <new-step
        @stepCreated="stepCreated"
        :desiredPosition="desiredPosition"
        :steppable-id="steppableId"
        :steppable-type="steppableType"
      />
    </b-modal>
  </section>
</template>

<script>
import NewStep from '@/components/concerns/Steps/NewStep'
import Step from '@/components/concerns/Steps/Step'
export default {
  props: ['owner', 'steppableId', 'steppableType', 'editing'],
  data () {
    return {
      steps: [],
      desiredPosition: null,
      isNewStepModalActive: false
    }
  },
  computed: {
    editingStatus: {
      get () {
        return this.editing
      },
      set (value) {
        this.$emit('editingUpdated', value)
      }
    }
  },
  components: {
    NewStep,
    Step
  },
  created () {
    this.fetchSteps()
  },
  methods: {
    triggerNewStepModal (desiredPosition) {
      this.desiredPosition = desiredPosition
      this.isNewStepModalActive = true
    },
    fetchSteps () {
      this.$store
        .dispatch('steps/index', {
          steppableId: this.steppableId,
          steppableType: this.steppableType
        })
        .then((resp) => {
          this.steps = resp.data.data
        })
        .catch((_) => {
          // TODO: Handle error
          console.log('Error on steps')
        })
    },
    deleteStep (stepId) {
      this.$store
        .dispatch('steps/destroy', {
          steppableId: this.steppableId,
          steppableType: this.steppableType,
          stepId: stepId
        })
        .then((resp) => {
          this.$buefy.toast.open({ message: 'Step deleted', type: 'is-danger' })
          this.steps = resp.data.data
        })
        .catch((error) => {
          // TODO: Handle error
          console.log(error.response)
        })
    },
    updateStep ({ id, payload }) {
      this.$store
        .dispatch('steps/update', {
          steppableId: this.steppableId,
          steppableType: this.steppableType,
          stepId: id,
          payload: payload
        })
        .then((resp) => {
          this.$buefy.toast.open({ message: 'Step updated', type: 'is-success' })
          this.steps = resp.data.data
        })
        .catch((error) => {
          // TODO: Handle error
          console.log(error.response)
        })
    },
    stopEditing () {
      this.editing = false
      // this.$buefy.dialog.confirm({
      //   message: 'Would you like to publish your updates on this craft?',
      //   onConfirm: () => {
      //     this.isPublishModalActive = true
      //   }
      // })
    },
    stepCreated (steps) {
      this.$buefy.toast.open({ message: 'Step created', type: 'is-success' })
      this.updateSteps(steps)
    },
    updateSteps (steps) {
      this.steps = steps
    }
  }
}
</script>
